import { useCallback, useState } from "react";

import { CloudinaryUpload } from "../CloudinaryUpload";

export const useResumeUpload = ({ onPrepareUpload, onUploadSuccess }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const handleUpload = useCallback(
    async (selectedFile) => {
      if (!selectedFile) {
        return;
      }

      setIsUploading(true);
      setUploadError(null);

      try {
        const uploadConfig = await onPrepareUpload?.();

        if (!uploadConfig) {
          setIsUploading(false);
          return;
        }

        const result = await CloudinaryUpload({
          file: selectedFile,
          publicId: uploadConfig.publicId,
          context: uploadConfig.context,
        });

        onUploadSuccess?.(result.publicId);
      } catch (error) {
        console.error("Error uploading resume:", error);
        setUploadError(
          error?.message || "Failed to upload resume. Please try again."
        );
      } finally {
        setIsUploading(false);
      }
    },
    [onPrepareUpload, onUploadSuccess]
  );

  const clearUploadError = useCallback(() => {
    setUploadError(null);
  }, []);

  return {
    isUploading,
    uploadError,
    handleUpload,
    clearUploadError,
  };
};
